import React, { Component } from 'react';
import HeaderTools from '../../PageComponents/Header/HeaderTools';
import apiService from '../../Services/apiServices';
import DataTable from  '../../PageComponents/UI/Tables/DataTable';
import helper from '../../Services/helper';
import { Link, useLocation } from "react-router-dom";
import { useToasts } from 'react-toast-notifications'
import { confirmAlert } from 'react-confirm-alert'; 
import Search from '../../PageComponents/Search/Search';
import Pagination from '../../PageComponents/UI/Pagination/Pagination';
import Item from '../../Models/Item';
import ImportData from '../Tools/ImportData';

//import '../Items/Items.js';

function withToast(Component) {
  return function WrappedComponent(props) {
      const toastFuncs = useToasts() 
      return <Component {...props} {...toastFuncs} />;
  }
}

class Items extends Component {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      search:'',
      salesType: [],
      units: [],
      showImportData: false 
    };
    // console.log('props: ', props);
    //this.search = this.search.bind(this);
    // if(!props.location.hash){
    //   this.getItems()
    // }

    
    this.getItems(props.location.hash);

    apiService()
      .get('units')
          .then((response) => {
              if (response.success) {
                  var records = response.data;//.map(record => ({ value: record.id, label: record.name  }));
                  this.setState({
                      ['units']: records
                  });
              } else {
                  console.log('Error:' + response.errorMessage);
              }
          });
    
  }
  handleChange(event) {
    // Get event value
    let searchValue = event.target.value;

    // Set the state to trigger a re-rendering
    this.setState({ search: searchValue });
}

//componentDidMount onload render data
componentDidMount() {
  //window.removeEventListener("hashchange", this.getItems(this.props.location.hash), false);
  window.addEventListener("hashchange", e =>  this.getItems(this.props.location.hash ));
}

// componentWillUnmount() {
//   window.removeEventListener("hashchange", this.getItems(this.props.location.hash), false);
// }

showImportData = () => {
  this.setState({
    showImportData: !this.state.showImportData
  })
}

getItems(hash) {
  apiService()
    .get('items')
    .then((response) => {
      if (response.success) {
        if(hash){
          if(hash !== '#expired'){
            var items = response.data.filter(items => items[hash.substring(1)] == true && items['expired'] == false);
            this.setState({ items: items });
          } 
          else {
            var items = response.data.filter(items => items[hash.substring(1)] == true);
            this.setState({ items: items });
          } 
        }
        else {
          var items = response.data
          this.setState({ items: items });
        }
        var saldo = 0.0;
        var prevItem = 0;
        for (var i = 0; i < items.length; i++) {
            if (items[i].itemId === prevItem) {
                saldo = saldo + items[i].quantity;
            } else {
                saldo = items[i].quantity;
            }
            items[i].saldo = saldo;
            items[i].total = saldo * items[i].price;
            prevItem = items[i].itemId;
            var unit = this.state.units.find(unit => unit.id == items[i].unitId)
            if(unit != undefined) {
              items[i].unit = unit.name
            }
            
        }

        this.setState({ data: items });
        
        
      } else {
        console.log('Error:' + response.errorMessage);
      }
    });
}

  onFieldChange = (e) => {
    this.setState({
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  edit = (item) => {
    window.location.href = `#/item/${item.id}`
  }

  delete = (id) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui" >
            <h1>A jeni te sigurt?</h1>
            <p>Dëshironi të fshini këtë artikull?</p>
            <button
              onClick={() => {
                  apiService().delete('items', id)
                      .then((response)=>{this.responseMessage(response, 'Delete Successfully')});
                  onClose();
              }}
            >
              Po , Fshije!
            </button>
            <button onClick={onClose}>Jo</button>
          </div>
        );
      }
    }) 
  }

  responseMessage = (response, message) => {
    let that = this;
    if(response.success){
        that.getItems(that.props.location.hash);
        that.props.addToast( message, { appearance: 'success', autoDismiss: true, });
    }
    else{
      that.props.addToast('Ka ndodhur nje gabim!', { appearance: 'error', autoDismiss: true, });
    }
  }

  render() {
    //ose dojme me zgjedh cilat kolona dojme me i shfaqe
    const headers = [
        { key: 'id', columnName: 'ID' },
        { key: 'barcode', columnName: helper().translate('BARCODE') },
        { key: 'itemName', columnName: helper().translate('ITEMNAME') },
        // { key: 'quantity', columnName: helper().translate('QUANTITY') },
        { key: 'unit', columnName: helper().translate('UNIT') },
        { key: 'retailPrice', columnName: helper().translate('PRICE') },
        // { key: 'date', columnName: helper().translate('DATE') },
        // { key: 'saldo', columnName: helper().translate('SALDO') },
        // { key: 'total', columnName: helper().translate('TOTAL') }
        { key: 'accountAName', columnName: helper().translate('ACCOUNT') + ' A' },
        { key: 'accountBName', columnName: helper().translate('ACCOUNT') + ' B'},
        { key: 'accountCName', columnName: helper().translate('ACCOUNT') + ' C' },
    ];

    const { data, items } = this.state;
    let searchItems = items,
        searchString = this.state.search.trim().toLowerCase();
        if (searchString.length > 0) {
            // We are searching. Filter the results.
            //searchItems = searchItems.filter((e) => e.itemName.toLowerCase().match(searchString));
            searchItems = searchItems.filter((item) => {
              return (
                item.itemName?.toLowerCase().match(searchString) ||
                item.barcode?.toLowerCase().match(searchString) ||
                item.unit?.toLowerCase().match(searchString) 
              )
            });
        }
    return (
      <div>
      <div className="container-fluid px-2 px-0 mt-3">
        <Search new={`#/item#${this.props.location.hash.substring(1)}`} change={(e) => this.handleChange(e)} importData={this.showImportData}/>
        <div className="card shadow mt-1">
            <div className="card-header py-2">
                <h6 className="m-0 font-weight-bold text-primary">Artikujt</h6>
            </div>     
            {this.state.showImportData && <ImportData queryName='items' model={new Item()} callBack={() => this.getItems(this.props.location.hash)}/>}                   
            <DataTable data={searchItems ? searchItems : items} showEdit={true} headersFrom={"ITEMS"} headers={headers} hash={this.props.location.hash} edit={ this.edit} delete={this.delete} />                      
        </div>
        

        {/* <div className="card shadow mt-1">
          <div className="card-header py-2">
            <h6 className="m-0 font-weight-bold text-primary">Artikujt</h6>
          </div>
          <div className="card-body table-responsive">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">Nr</th>
                  <th scope="col">Emri</th>
                  <th scope="col">Barkodi</th>
                  <th scope="col">Njesia</th>
                  <th scope="col">Sasia</th>
                  <th scope="col">Cmimi Shitjes</th>
                  <th scope="col">Cmimi Mesatar</th>
                  <th scope="col">Totali</th>
                  <th className="buttons" scope="col">Edit / Delete</th>
                </tr>
              </thead>
              {searchItems.map((item, index) => (
                <tbody>
                  <tr key={index}>
                    <td> {item.Nr}</td>
                    <td> <a href={`#/item/${item.id}`}>{item.itemName}</a></td>
                    <td> {item.barcode} </td>
                    <td> {item.unit} </td>
                    <td> {item.Quantity?.toFixed(2)}</td>
                    <td> {item.SalePrice?.toFixed(2)}</td>
                    <td> {item.AvgPrice?.toFixed(2)}</td>
                    <td> {(item.AvgPrice * item.Quantity)?.toFixed(2)}</td>
                    <td>
                      <a href={`#/item/${item.id}`} className="btn-edit mr-2">
                        <span className="icon text-white-40">
                          <i className="fas fa-edit" />
                        </span>
                      </a>
                      <button onClick={() => this.delete(item.id)} className="btn-delete mr-2">
                        <span className="icon text-white-40">
                          <i className="fas fa-trash" />
                        </span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              ))}
            </table>
          </div>
        </div> */}
      </div>
    </div>
    );
  }
}

export default withToast(Items);



// WEBPACK FOOTER //
// ./src/PageComponents/Items/Items.js